import React from 'react';
import { SideMenuItem, SideMenuSpacer }  from '../SidemenuItems';
import { Div } from '../../../../components/grid';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/leverandoer-sodavand-kildevand-oel" title="Din leverandør af sodavand, kildevand & øl" active={activeSidemenu === 'Leverandoer'} main />
    <SideMenuSpacer />
    <SideMenuItem title="Kildevand" to="/kildevand" active={activeSidemenu === 'Kildevand'} />
    <SideMenuItem title="Aqua d'or" to="/kildevand/aquador" active={activeSidemenu === 'Aquador'} />
    <SideMenuItem title="Denice Vand" to="/kildevand/denice-vand" active={activeSidemenu === 'DeniceVand'} />
    <SideMenuItem title="Kildevand i paller" to="/kildevand/vand-paller" active={activeSidemenu === 'VandPaller'} />
    <SideMenuItem title="Vand med Logo" to="/kildevand/vand-med-logo" active={activeSidemenu === 'VandLogo'} />
    <SideMenuItem title="San Pellegrino Vand" to="/kildevand/san-pellegrino-vand" active={activeSidemenu === 'SanPellegrinoVand'} />
    <SideMenuItem title="Vand uden pant" to="/kildevand/vand-uden-pant" active={activeSidemenu === 'VandUdenPant'} />
    <SideMenuItem title="Vitamin Well" to="/kildevand/vitamin-well" active={activeSidemenu === 'VitaminWell'} />
  </Div>
);
